import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  const isAuthenticatedUser = Vue.prototype.$storage.getUniversal('isAuthenticatedUser')

  if (to.meta.private && !isAuthenticatedUser) {
    next({ name: 'Login' })
    localStorage.clear()
  } else if (to.meta.public && isAuthenticatedUser) {
    next({ name: 'Dashboard' })
  } else {
    next()
  }
})

export default router
